import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate, useLocation } from 'react-router-dom';
import { withSuspense } from '@/components/base/LazyPage';
import NotFound from '@/pages/NotFound';

const Home = withSuspense(lazy(() => import('@/pages/home/page')));
const Contact = withSuspense(lazy(() => import('@/pages/contact/page')));
const GetInvolved = withSuspense(lazy(() => import('@/pages/get-involved/page')));
const UkProtest = withSuspense(lazy(() => import('@/pages/uk-protest/page')));
const MiamiProtest = withSuspense(lazy(() => import('@/pages/miami-protest/page')));
const Evidence = withSuspense(lazy(() => import('@/pages/evidence/page')));
const DefenseEvidence = withSuspense(lazy(() => import('@/pages/evidence/defense/page')));
const UkDefenseAnalysis = withSuspense(lazy(() => import('@/pages/evidence/uk-defense/page')));

function LegacyDefenseRedirect() {
  const { search, hash } = useLocation();
  return <Navigate replace to={{ pathname: '/evidence/defense-romania', search, hash }} />;
}
const AboutTheTates = withSuspense(lazy(() => import('@/pages/about-the-tates/page')));
const Faq = withSuspense(lazy(() => import('@/pages/faq/page')));
const ReasonToProtest = withSuspense(lazy(() => import('@/pages/reason-to-protest/page')));
const Fans = withSuspense(lazy(() => import('@/pages/fans/page')));
const LegalTimeline = withSuspense(lazy(() => import('@/pages/legal-timeline/page')));
const Terms = withSuspense(lazy(() => import('@/pages/terms/page')));
const Biography = withSuspense(lazy(() => import('@/pages/biography/page')));
const TristanBiography = withSuspense(lazy(() => import('@/pages/tristan-biography/page')));
const TheMatrix = withSuspense(lazy(() => import('@/pages/the-matrix/page')));
const TheArchive = withSuspense(lazy(() => import('@/pages/the-archive/page')));
const Donate = withSuspense(lazy(() => import('@/pages/donate/page')));
const MissedCourtAppearances = withSuspense(lazy(() => import('@/pages/missed-court-appearances/page')));
const WilPujols = withSuspense(lazy(() => import('@/pages/wil-pujols/page')));
const UkCase = withSuspense(lazy(() => import('@/pages/uk-case/page')));
const ContributionPolicy = withSuspense(lazy(() => import('@/pages/contribution-policy/page')));
const JaneDoeDefamation = withSuspense(lazy(() => import('@/pages/jane-doe-defamation/page')));
const OnlineDefamation = withSuspense(lazy(() => import('@/pages/online-defamation/page')));
const MatrixAgents = withSuspense(lazy(() => import('@/pages/matrix-agents/page')));
const UsExtradition = withSuspense(lazy(() => import('@/pages/us-extradition/page')));
const PencovVDoe = withSuspense(lazy(() => import('@/pages/pencov-v-doe/page')));
const CaseCredits = withSuspense(lazy(() => import('@/pages/case-credits/page')));
const LatestMatrixAttack = withSuspense(lazy(() => import('@/pages/latest-matrix-attack/page')));
const RomaniaVsTateBrothers = withSuspense(lazy(() => import('@/pages/romania-vs-tate-brothers/page')));
const WilPujolsWitnessList = withSuspense(lazy(() => import('@/pages/wil-pujols-witness-list/page')));
const MiamiSupportersMarch = withSuspense(lazy(() => import('@/pages/events/miami-supporters-march-august-26-2026')));
const MiamiCourtProtest = withSuspense(lazy(() => import('@/pages/events/miami-court-protest-august-27-2026')));
const SeptemberBondUpdate = withSuspense(lazy(() => import('@/pages/september-update/page')));
const OctoberExtraditionUpdate = withSuspense(lazy(() => import('@/pages/october-1-update/page')));
const HabeasOctoberUpdate = withSuspense(lazy(() => import('@/pages/updates/tate-habeas-corpus-october-23-2026/page')));
const CourtDocuments = withSuspense(lazy(() => import('@/pages/court-documents/page')));
const Studio66Investigation = withSuspense(lazy(() => import('@/pages/investigations/studio-66/page')));
const InvestigationsArchive = withSuspense(lazy(() => import('@/pages/investigations/page')));
const ImageOriginInvestigation = withSuspense(lazy(() => import('@/pages/investigations/where-did-the-images-come-from-mainstream-media/page')));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/contact',
    element: <Navigate to="/get-involved" replace />,
  },
  {
    path: '/get-involved',
    element: <GetInvolved />,
  },
  {
    path: '/london-protest',
    element: <UkProtest />,
  },
  {
    path: '/uk-protest',
    element: <Navigate to="/london-protest" replace />,
  },
  {
    path: '/miami-protest',
    element: <MiamiProtest />,
  },
  {
    path: '/evidence',
    element: <Evidence />,
  },
  {
    path: '/evidence/defense',
    element: <LegacyDefenseRedirect />,
  },
  {
    path: '/evidence/defense-romania',
    element: <DefenseEvidence />,
  },
  {
    path: '/evidence/uk-defense',
    element: <UkDefenseAnalysis />,
  },
  {
    path: '/about-the-tates',
    element: <AboutTheTates />,
  },
  {
    path: '/faq',
    element: <Faq />,
  },
  {
    path: '/romania-case',
    element: <ReasonToProtest />,
  },
  {
    path: '/fans',
    element: <Fans />,
  },
  {
    path: '/legal-timeline',
    element: <LegalTimeline />,
  },
  {
    path: '/Andrew-tate',
    element: <Biography />,
  },
  {
    path: '/biography',
    element: <Navigate to="/Andrew-tate" replace />,
  },
  {
    path: '/Tristan-tate',
    element: <TristanBiography />,
  },
  {
    path: '/tristan-biography',
    element: <Navigate to="/Tristan-tate" replace />,
  },
  {
    path: '/the-matrix',
    element: <TheMatrix />,
  },
  {
    path: '/the-archive',
    element: <TheArchive />,
  },
  {
    path: '/donate',
    element: <Donate />,
  },
  {
    path: '/missed-court-appearances',
    element: <MissedCourtAppearances />,
  },
  {
    path: '/wil-pujols',
    element: <WilPujols />,
  },
  {
    path: '/uk-case',
    element: <UkCase />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/contribution-policy',
    element: <ContributionPolicy />,
  },
  {
    path: '/jane-doe-defamation',
    element: <JaneDoeDefamation />,
  },
  {
    path: '/online-defamation',
    element: <OnlineDefamation />,
  },
  {
    path: '/matrix-agents',
    element: <MatrixAgents />,
  },
  {
    path: '/us-extradition',
    element: <UsExtradition />,
  },
  {
    path: '/extradition',
    element: <UsExtradition />,
  },
  { path: '/updates/tate-habeas-corpus-october-23-2026', element: <HabeasOctoberUpdate /> },
  { path: '/court-documents', element: <CourtDocuments /> },
  { path: '/investigations/studio-66', element: <Studio66Investigation /> },
  { path: '/investigations', element: <InvestigationsArchive /> },
  { path: '/investigations/where-did-the-images-come-from-mainstream-media', element: <ImageOriginInvestigation /> },
  {
    path: '/pencov-v-doe',
    element: <PencovVDoe />,
  },
  {
    path: '/case-credits',
    element: <CaseCredits />,
  },
  {
    path: '/latest-matrix-attack',
    element: <LatestMatrixAttack />,
  },
  {
    path: '/romania-vs-tate-brothers',
    element: <RomaniaVsTateBrothers />,
  },
  {
    path: '/wil-pujols-witness-list',
    element: <WilPujolsWitnessList />,
  },
  {
    path: '/events/miami-supporters-march-august-26-2026',
    element: <MiamiSupportersMarch />,
  },
  {
    path: '/events/miami-court-protest-august-27-2026',
    element: <MiamiCourtProtest />,
  },
  {
    path: '/updates/september-9-bond-denial',
    element: <Navigate to="/updates/uk-formal-extradition-requests-submitted" replace />,
  },
  {
    path: '/updates/uk-formal-extradition-requests-submitted',
    element: <SeptemberBondUpdate />,
  },
  {
    path: '/updates/october-1-extradition-scheduling',
    element: <OctoberExtraditionUpdate />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;